import { selector } from 'recoil';
import { startingDate } from '../atoms/startingDate';
import { endingDate } from '../atoms/endingDate';
import { user } from '../atoms/user';
import { methodNameEnum } from './makePHPRequest';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';

export const businessUserTimeSavedReporting = selector({
  key: 'businessUserTimeSavedReporting',
  get: async ({ get }) => {
    try {
      const start = get(startingDate);
      const end = get(endingDate);
      const storageUser = get(user);
      const data = {
        call: methodNameEnum.GET_BUSINESS_DATA,
      };
      const businessData = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_BUSINESS_DATA,
          payloadJsonString: JSON.stringify(data),
        })
      );
      event.connectionLimit =
        businessData?.response?.data?.result?.[0]?.connectionDuration;
      event.businessid = storageUser.businessid;
      event.apiKey = storageUser.apikey;
      event.startdate = start;
      event.enddate = end;
      const result = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_BUSINESS_USER_TIME_SAVED_REPORTING,
          payloadJsonString: JSON.stringify(event),
        })
      );
      return result;
    } catch (error) {
      throw error;
    }
  },
});
